__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "ChemcatbioApp";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@hero/federation-library", "1.0.5", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(757)]).then(() => (() => (__webpack_require__(75757))))));
			register("@hero/hero-auth-app", "1.7.2", () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(914), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(93215))))));
			register("@hero/hero-data-repo-app", "1.7.0", () => (Promise.all([__webpack_require__.e(154), __webpack_require__.e(914), __webpack_require__.e(467)]).then(() => (() => (__webpack_require__(17154))))));
			register("@hero/hero-notifications-app", "1.3.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(342)]).then(() => (() => (__webpack_require__(37961))))));
			register("@hero/hero-platform-ui-app", "0.13.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(641)]).then(() => (() => (__webpack_require__(9641))))));
			register("@hero/hero-sdk", "0.10.2", () => (__webpack_require__.e(763).then(() => (() => (__webpack_require__(85763))))));
			register("@hero/hero-search-app", "1.6.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(441)]).then(() => (() => (__webpack_require__(73441))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(248), __webpack_require__.e(657), __webpack_require__.e(928), __webpack_require__.e(355), __webpack_require__.e(870), __webpack_require__.e(400), __webpack_require__.e(828), __webpack_require__.e(914), __webpack_require__.e(291), __webpack_require__.e(833)]).then(() => (() => (__webpack_require__(19828))))));
			register("@mui/system", "5.18.0", () => (Promise.all([__webpack_require__.e(248), __webpack_require__.e(400), __webpack_require__.e(806), __webpack_require__.e(914), __webpack_require__.e(846)]).then(() => (() => (__webpack_require__(64806))))));
			register("@nrel-design-system/hero", "0.10.14", () => (Promise.all([__webpack_require__.e(248), __webpack_require__.e(657), __webpack_require__.e(928), __webpack_require__.e(870), __webpack_require__.e(742), __webpack_require__.e(914), __webpack_require__.e(291), __webpack_require__.e(833), __webpack_require__.e(241), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(62742))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(914), __webpack_require__.e(291)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};